// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1cGKY","copyright":"Footer_copyright__2UojN"};